import React from 'react';
import styles from './Card.module.css';
import { Link } from 'react-router-dom';

const Card = ({ image, heading, text, link }) => {
  return (
    <div className={styles.container}>
      <img src={image} alt="" className={styles.image} />

      <div className={styles.textContainer}>
        <h2 className={styles.heading}>{heading}</h2>
        <p className={styles.text}>{text}</p>
        <Link to={link}>
          <p className={styles.linkText}>了解更多 &#8594;</p>
        </Link>
      </div>
    </div>
  );
};

export default Card;
